/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

//This will contains the RGB to CMYK color mapping
/*Colorname C/M/Y/K R/G/B Hex
Black 0/0/0/100 35/31/32 #231f20
Blue 76/25/0/0 15/153/214 #0f99d6
Gray 57/41/34/4 119/133/145 #778591
Green 75/4/100/0 64/174/73 #40ae49
Orange 0/72/100/0 243/108/33 #f36c21
Red 1/100/92/0 234/29/45 #ea1d2d
White 0/0/0/0 255/255/255 #ffffff
Yellow 16/31/100/0 218/173/40 #daad28*/
export const RGB_TO_CMYK = {
    '35/31/32': '0/0/0/100',
    '15/153/214': '76/25/0/0',
    '119/133/145': '57/41/34/4',
    '64/174/73': '75/4/100/0',
    '243/108/33': '0/72/100/0',
    '234/29/45': '1/100/92/0',
    '255/255/255': '0/0/0/0',
    '218/173/40': '16/31/100/0'
};
//Text Align Styles
export const TEXT_ALIGNMENT_STYLES = {
    left: {labelText: 'Left', icon: 'text-align-left-24', templateAlign: 'x-left', cssAlign: 'left'},
    right: {labelText: 'Right', icon: 'text-align-right-24', templateAlign: 'x-right', cssAlign: 'right'},
    center: {labelText: 'Center', icon: 'text-align-center-24', templateAlign: 'x-center', cssAlign: 'center'},
    justify: {labelText: 'Justify', icon: 'text-align-justify-24', templateAlign: 'x-justify', cssAlign: 'justify'}
};

//Tool ox Drop Down Fonts
export const DROP_DOWN_FONTS = [
    'universltw01-55roman.ttf',
    'bodoniw01-roman.ttf',
    'tradegothicltw01-roman.ttf',
    'bembow01.ttf',
    'itcavantgardegothicw01-bk.ttf',
    'laurentianw04-regular.ttf'
];
//This will contains the Web Font to Print Font mapping
export const PRINT_FONT_TO_WEB_FONT = {
    'universltw01-55roman.ttf': {
        selectName: 'Univers',
        fontFamily: 'univers'
    },
    'bodoniw01-roman.ttf': {
        selectName: 'Bodoni',
        fontFamily: 'bodoni'
    },
    'tradegothicltw01-roman.ttf': {
        selectName: 'Trade Gothic',
        fontFamily: 'tradeGothic'
    },
    'bembow01.ttf': {
        selectName: 'Bembo',
        fontFamily: 'bembo'
    },
    'itcavantgardegothicw01-bk.ttf': {
        selectName: 'ITC Avant Garde',
        fontFamily: 'ItcAvantGarde'
    },
    'laurentianw04-regular.ttf': {
        selectName: 'Laurentian Pro',
        fontFamily: 'laurentianPro'
    },
    'bembomtw01-italic.ttf': {
        selectName: 'Bembo Italic',
        fontFamily: 'bemboItalic'
    },
    'bembomtw01-semibold.ttf': {
        selectName: 'Bembo Semibold',
        fontFamily: 'bemboSemiBold'
    },
    'bembomtw01-semibolditalic.ttf': {
        selectName: 'Bembo Semibold Italic',
        fontFamily: 'bemboSemiboldItalic'
    },
    'tradegothicltw01-bdcnno.20.ttf': {
        selectName: 'Trade Gothic Bdcn',
        fontFamily: 'tradeGothicBdcn'
    },
    'universltw01-45light.ttf': {
        selectName: 'Univers Light',
        fontFamily: 'universLight'
    },
    'universltw01-47lightcond.ttf': {
        selectName: 'Univers Light Cond',
        fontFamily: 'universLightCond'
    },
    'universltw01-57condensed.ttf': {
        selectName: 'Univers  Cond',
        fontFamily: 'universCond'
    },
    'universltw01-57condensedobl.ttf': {
        selectName: 'Univers  Cond Obl',
        fontFamily: 'universCondObl'
    },
    'universltw01-67boldcond.ttf': {
        selectName: 'Univers  Bold Cond',
        fontFamily: 'universBoldCond'
    }

};

export const WEB_FONT_FAMILY_TO_PRINT_FONT = (() => {
    const fontFamilyMap = {};
    for (const key in PRINT_FONT_TO_WEB_FONT) {
        if (PRINT_FONT_TO_WEB_FONT.hasOwnProperty(key)) {
            const fontObj = PRINT_FONT_TO_WEB_FONT[key];
            fontFamilyMap[fontObj.fontFamily] = {printFont: key};
        }
    }
    return fontFamilyMap;
})();



// WEBPACK FOOTER //
// ./src/components/widgets/CoverPage/cover.constants.js